<ion-header>
  <ion-toolbar color="primary">
    <ion-buttons slot="start">
      @if (isModal) {
        <ion-button (click)="modalController.dismiss()">{{ 'core.done' | translate }}</ion-button>
      } @else {
        <ion-back-button defaultHref="/" [text]="'core.backButton' | translate"></ion-back-button>
      }
    </ion-buttons>
    <ion-title>{{ 'campus-navi.title' | translate }}</ion-title>
    <ion-buttons slot="end">
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content [forceOverscroll]="false">
  <app-map [trackUserLocation]="trackUserLocation" [enabledCategories]="enabledCategories | async" [showCategories]="showCategories" (changeCategories)="changeCategories($event)"></app-map>
</ion-content>
